export const CREATE_BENEFIT_GROUPS_CACHE_KEY = 'benefitGroups';

export const CREATE_BENEFIT_GROUP_API_TAG = 'getBenefitGroups';
